import { normalizeSaleContact } from "./normalise-sale-contact.type";
import { normalizeBusinessContact } from "./normalise-business-contact.type";
import { normalizeCareer } from "./normalise-career.type";
import { normalizeCompany } from "./normalise-company.type";
import { normalizeContact } from "./normalise-contact.type";
import { normalizeFooter } from "./normalise-footer.type";
import { normalizeHeader } from "./normalise-header.type";
import { normalizeJobDetail } from "./normalise-job-detail.type";
import { normalizeProduct } from "./normalise-product.type";
import { ContentVersionBase } from "../workflow.type";

export type NormalizedAnyPage = Record<string, any> & {
  page: string;
};

export type PageNormalizer = (
  item: ContentVersionBase
) => NormalizedAnyPage | null;

export const normalizerMap: Record<string, PageNormalizer> = {
  saleContact: normalizeSaleContact as PageNormalizer,
  businessContact: normalizeBusinessContact as PageNormalizer,
  career: normalizeCareer as PageNormalizer,
  company: normalizeCompany as PageNormalizer,
  contact: normalizeContact as PageNormalizer,
  footer: normalizeFooter as PageNormalizer,
  header: normalizeHeader as PageNormalizer,
  jobDetail: normalizeJobDetail as PageNormalizer,
  product: normalizeProduct as PageNormalizer,
};

export function getPageKeyFromVersion(item: ContentVersionBase): string {
  const keys = item?.data ? Object.keys(item.data) : [];
  return keys[0] ?? "";
}

export type CompareResult<T> = {
  changedPublishedOnly: Partial<T>;
  changedDraftOnly: Partial<T>;
  diff: Record<
    string,
    {
      published: unknown;
      draft: unknown;
    }
  >;
};

const isSame = (a: unknown, b: unknown) =>
  JSON.stringify(a) === JSON.stringify(b);

export function compareChangedSectionsGeneric<T extends Record<string, any>>(
  published: T,
  draft: T
): CompareResult<T> {
  const changedPublishedOnly: Partial<T> = {};
  const changedDraftOnly: Partial<T> = {};
  const diff: Record<string, { published: unknown; draft: unknown }> = {};

  const keys = new Set([
    ...Object.keys(published ?? {}),
    ...Object.keys(draft ?? {}),
  ]);

  keys.forEach((key) => {
    if (key === "page") return;

    const publishedValue = published[key];
    const draftValue = draft[key];

    if (!isSame(publishedValue, draftValue)) {
      changedPublishedOnly[key as keyof T] = publishedValue;
      changedDraftOnly[key as keyof T] = draftValue;
      diff[key] = {
        published: publishedValue,
        draft: draftValue,
      };
    }
  });

  return {
    changedPublishedOnly,
    changedDraftOnly,
    diff,
  };
}